import { LOCALES } from 'i18n/locales';

export const enhancedMeasuresModalIntl = {
    [LOCALES.ENGLISH]: {
        'enhancedMeasures.modal.title': 'Asset owners with enhanced measures',
        'enhancedMeasures.modal.summary.plural': '{count} asset owners with enhanced measures found within your search area.',
        'enhancedMeasures.modal.summary.singular': '{count} asset owner with enhanced measures found within your search area.',
        'enhancedMeasures.modal.redactedSummary.plural': '{count} hidden assets found',
        'enhancedMeasures.modal.redactedSummary.singular': '{count} hidden asset found',
        'enhancedMeasures.modal.review': 'Review enhanced measures'
    },
    [LOCALES.WELSH]: {
        'enhancedMeasures.modal.title': '[Asset owners with enhanced measures]',
        'enhancedMeasures.modal.summary.plural': '[{count} asset owners with enhanced measures found within your search area.]',
        'enhancedMeasures.modal.summary.singular': '[{count} asset owner with enhanced measures found within your search area.]',
        'enhancedMeasures.modal.redactedSummary.plural': '[{count} hidden assets found]',
        'enhancedMeasures.modal.redactedSummary.singular': '[{count} hidden asset found]',
        'enhancedMeasures.modal.review': '[Review enhanced measures]'
    }
};
